import { useCallback } from 'react';
import { useMedplum } from '@medplum/react';
import { Patient } from '@medplum/fhirtypes';
import {
  SurgeryInputItem,
  mapProceduresToSurgeryInputs,
} from '@/utils/surgery.utils';
import { HL7 } from '@/consts/systems.consts';

export interface UseProceduresReturn {
  loadPatientProcedures: (patient: Patient) => Promise<{
    procedures: SurgeryInputItem[];
  }>;
}

export function useProcedures(): UseProceduresReturn {
  const medplum = useMedplum();

  const loadPatientProcedures = useCallback(
    async (
      patient: Patient
    ): Promise<{
      procedures: SurgeryInputItem[];
    }> => {
      if (!patient?.id) {
        return {
          procedures: [],
        };
      }

      // Load medical history procedures
      const procedures = await medplum.searchResources('Procedure', {
        subject: `Patient/${patient.id}`,
        category: `${HL7.TERMINOLOGY.CS.CONDITION.CATEGORY.BASE}|${HL7.TERMINOLOGY.CS.CONDITION.CATEGORY.CODES.MEDICAL_HISTORY}`,
      });

      const procedureInputs = mapProceduresToSurgeryInputs(procedures);

      return {
        procedures: procedureInputs,
      };
    },
    [medplum]
  );

  return { loadPatientProcedures };
}
